// extracted by mini-css-extract-plugin
export var black = "Logo-module--black--aZkSB";
export var goldDark = "Logo-module--goldDark--McMkH";
export var img = "Logo-module--img--a2y0Q";
export var root = "Logo-module--root--It7ax";
export var svg = "Logo-module--svg--i1bxk";